import { render, staticRenderFns } from "./cell-account-provider.vue?vue&type=template&id=5da21bf8&scoped=true"
import script from "./cell-account-provider.ts?vue&type=script&lang=ts&external"
export * from "./cell-account-provider.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-account-provider.vue?vue&type=style&index=0&id=5da21bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da21bf8",
  null
  
)

export default component.exports